import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";

import EmployeeTableToolbar from "../../shared/table/EmployeeTableToolbar";
import StyledTableCell from "../../../styles/tableCell.jsx";
import StyleTableRow from "../../../styles/styleTableRow";
import TableHeadEmployee from "../../shared/table/TableHeadEmployee";
import { TablePagination, Checkbox, TableCell } from "@material-ui/core";
import {
  changeRowsPerPage,
  getComparator,
  handleRequestSort,
  handleSelectAllClick,
  stableSort,
} from "../../../_utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  rowSelected: {
    "&:hover": {
      backgroundColor: "#ccebff !important",
    },
  },
}));

const headCells = [
  { id: "name", disablePadding: true, label: "Nombre" },
  { id: "direction", disablePadding: false, label: "Dirección" },
  { id: "alias", disablePadding: false, label: "Alias" },
  { id: "timeGuarantee", disablePadding: false, label: "Tiempo de garantía" },
  { id: "providerCode", disablePadding: false, label: "Clave de producto" },
  { id: "providerActive", disablePadding: false, label: "Proveedor activo" },
];

const ProviderTable = ({
  resetCheckox,
  providersArray,
  isUserDeleted,
  loadUsers,
}) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [providerArray, setProviderArray] = React.useState(providersArray);
  /**Check box options */
  const [selected, setSelected] = React.useState([]);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  useEffect(() => {
    setProviderArray(providersArray);
  }, [providersArray]);

  useEffect(() => {
    if (resetCheckox) setSelected([]);
  }, [resetCheckox]);

  const handleClick = (event, providerId) => {
    const selectedIndex = selected.indexOf(providerId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, providerId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, providerArray.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <EmployeeTableToolbar
          usersSelected={selected}
          isUserDeleted={isUserDeleted}
          loadUsers={loadUsers}
          type="provider"
          title="Lista de proveedores "
          label=" proveedores seleccionados"
        />
        <TableContainer style={{ marginTop: 20 }}>
          <Table
            className={classes.table}
            aria-label="simple table"
            size={"medium"}
          >
            <TableHeadEmployee
              classes={classes}
              numSelected={selected.length}
              order={order}
              headCells={headCells}
              orderBy={orderBy}
              onSelectAllClick={(e) =>
                setSelected(handleSelectAllClick(e, providerArray))
              }
              onRequestSort={(event, prop) => {
                const { property, ordering } = handleRequestSort(
                  event,
                  prop,
                  orderBy,
                  order
                );
                setOrder(ordering);
                setOrderBy(property);
              }}
              rowCount={providerArray.length}
            />
            <TableBody>
              {stableSort(providerArray, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <StyleTableRow
                      key={row.name}
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      className={classes.rowSelected}
                      selected={isItemSelected}
                    >
                      <StyledTableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          color="primary"
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        scope="row"
                        align="center"
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.direction}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.alias}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <Chip
                          style={{ padding: 15 }}
                          label={row.timeGuarantee || ""}
                          color="primary"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.providerCode}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ fontWeight: 700 }}
                      >
                        {row.providerActive ? "Si" : "No"}
                      </StyledTableCell>
                    </StyleTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <StyledTableCell style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </StyledTableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={providerArray.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={(e) => {
            const { rowsPerPage, page } = changeRowsPerPage(e);
            setRowsPerPage(rowsPerPage);
            setPage(page);
          }}
        />
      </Paper>
    </div>
  );
};

export default ProviderTable;
